import { createRouter, createWebHistory } from 'vue-router'
import { i18n } from '$/locales'

// ===== AUTH =====
import AuthContainer from '&/auth/AuthContainer.vue'
import SignUp from '&/auth/SignUp.vue'
import SignIn from '&/auth/SignIn.vue'
import ForgotPassword from '&/auth/ForgotPassword.vue'
import ResetPassword from '&/auth/ResetPassword.vue'
import ResendConfirmationEmail from '&/auth/ResendConfirmationEmail.vue'
import AccountContainer from '&/auth/AccountContainer.vue'
import MyPlan from '&/auth/MyPlan.vue'
import MyAccount from '&/auth/MyAccount.vue'
import MySetting from '&/auth/MySetting.vue'
import MyTask from '&/auth/MyTask.vue'

// ===== MAIN =====
import TheContainer from '&/TheContainer.vue'
import FeatureIndex from '&/FeatureIndex.vue'
import FeatureFaceSwap from '&/FeatureFaceSwap.vue'
import FeatureRemoveBackground from '&/FeatureRemoveBackground.vue'
import FeatureRemoveBackgroundResult from '&/FeatureRemoveBackgroundResult.vue'
import FeatureUpscaleAndEnhance from '&/FeatureUpscaleAndEnhance.vue'
import FeatureUpscaleAndEnhanceResult from '&/FeatureUpscaleAndEnhanceResult.vue'
import FeatureRestoreOldPhoto from '&/FeatureRestoreOldPhoto.vue'
import FeatureRestoreOldPhotoResult from '&/FeatureRestoreOldPhotoResult.vue'
import FeatureBlurFace from '&/FeatureBlurFace.vue'
import FeatureBlurFaceResult from '&/FeatureBlurFaceResult.vue'
import FeatureBlurBackground from '&/FeatureBlurBackground.vue'
import FeatureBlurBackgroundResult from '&/FeatureBlurBackgroundResult.vue'
import FeatureTrimTransparent from '&/FeatureTrimTransparent.vue'
import FeatureTrimTransparentResult from '&/FeatureTrimTransparentResult.vue'
import FeatureGenerateShadow from '&/FeatureGenerateShadow.vue'
import FeatureGenerateShadowResult from '&/FeatureGenerateShadowResult.vue'
import FeatureCompressImage from '&/FeatureCompressImage.vue'
import FeatureCompressImageResult from '&/FeatureCompressImageResult.vue'
import FeatureCropImage from '&/FeatureCropImage.vue'
import FeatureCropImageResult from '&/FeatureCropImageResult.vue'
import FeatureResizeImage from '&/FeatureResizeImage.vue'
import FeatureResizeImageResult from '&/FeatureResizeImageResult.vue'
import FeatureConvertImage from '&/FeatureConvertImage.vue'
import FeatureConvertImageResult from '&/FeatureConvertImageResult.vue'
import FeatureRotateImage from '&/FeatureRotateImage.vue'
import FeatureRotateImageResult from '&/FeatureRotateImageResult.vue'
import FeatureColorizeBlackAndWhite from '&/FeatureColorizeBlackAndWhite.vue'
import FeatureColorizeBlackAndWhiteResult from '&/FeatureColorizeBlackAndWhiteResult.vue'

// ===== LANDING PAGES =====
import PageFAQ from '&/landing_pages/PageFAQ.vue'
import PageContact from '&/landing_pages/PageContact.vue'
import PagePricing from '&/landing_pages/PagePricing.vue'
import PageChangePlan from '&/landing_pages/PageChangePlan.vue'
import PageHelp from '&/landing_pages/PageHelp.vue'

// =============================
// FEATURE ROUTES
// =============================
const featureRoutes = [
  { path: '', name: 'FeatureIndex', component: FeatureIndex },
  { path: 'face-swap', name: 'FaceSwap', component: FeatureFaceSwap },
  { path: 'upscale-and-enhance-image', name: 'UpscaleAndEnhance', component: FeatureUpscaleAndEnhance },
  {
    path: 'result/upscale-and-enhance-image',
    name: 'UpscaleAndEnhanceResult',
    component: FeatureUpscaleAndEnhanceResult,
  },
  { path: 'restore-old-photo', name: 'FeatureRestoreOldPhoto', component: FeatureRestoreOldPhoto },
  { path: 'result/restore-old-photo', name: 'RestoreOldPhotoResult', component: FeatureRestoreOldPhotoResult },
  { path: 'colorize-black-and-white-photo', name: 'ColorizeBlackAndWhite', component: FeatureColorizeBlackAndWhite },
  {
    path: 'result/colorize-black-and-white-photo',
    name: 'ColorizeBlackAndWhiteResult',
    component: FeatureColorizeBlackAndWhiteResult,
  },
  { path: 'remove-background', name: 'RemoveBackground', component: FeatureRemoveBackground },
  { path: 'result/remove-background', name: 'RemoveBackgroundResult', component: FeatureRemoveBackgroundResult },
  { path: 'blur-face', name: 'BlurFace', component: FeatureBlurFace },
  { path: 'result/blur-face', name: 'BlurFaceResult', component: FeatureBlurFaceResult },
  { path: 'blur-background', name: 'BlurBackground', component: FeatureBlurBackground },
  { path: 'result/blur-background', name: 'BlurBackgroundResult', component: FeatureBlurBackgroundResult },
  { path: 'trim-transparent-pixels', name: 'TrimTransparent', component: FeatureTrimTransparent },
  { path: 'result/trim-transparent-pixels', name: 'TrimTransparentResult', component: FeatureTrimTransparentResult },
  { path: 'image-shadow-generator', name: 'GenerateShadow', component: FeatureGenerateShadow },
  { path: 'result/image-shadow-generator', name: 'GenerateShadowResult', component: FeatureGenerateShadowResult },
  { path: 'compress-image', name: 'CompressImage', component: FeatureCompressImage },
  { path: 'result/compress-image', name: 'CompressImageResult', component: FeatureCompressImageResult },
  { path: 'crop-image', name: 'CropImage', component: FeatureCropImage },
  { path: 'result/crop-image', name: 'CropImageResult', component: FeatureCropImageResult },
  { path: 'resize-image', name: 'ResizeImage', component: FeatureResizeImage },
  { path: 'result/resize-image', name: 'ResizeImageResult', component: FeatureResizeImageResult },
  { path: 'convert-image', name: 'ConvertImage', component: FeatureConvertImage },
  { path: 'result/convert-image', name: 'ConvertImageResult', component: FeatureConvertImageResult },
  { path: 'rotate-image', name: 'RotateImage', component: FeatureRotateImage },
  { path: 'result/rotate-image', name: 'RotateImageResult', component: FeatureRotateImageResult },
]

// =============================
// ROUTES
// =============================
const routes = [
  // All routes with optional lang parameter (en has no prefix, vi/ja have prefix)
  {
    path: '/:lang(vi|ja)?',
    component: TheContainer,
    children: [
      ...featureRoutes,
      { path: 'help/:slug', name: 'PageHelp', component: PageHelp, props: true },
      { path: 'help/faq', name: 'PageFAQ', component: PageFAQ },
      { path: 'contact', name: 'PageContact', component: PageContact },
      { path: 'pricing', name: 'PagePricing', component: PagePricing },
      { path: 'change_plan', name: 'PageChangePlan', component: PageChangePlan },
    ],
  },

  // Auth routes (no prefix)
  {
    path: '/auth',
    component: AuthContainer,
    children: [
      { path: 'sign_up', name: 'SignUp', component: SignUp },
      { path: 'sign_in', name: 'SignIn', component: SignIn },
      { path: 'forgot_password', name: 'ForgotPassword', component: ForgotPassword },
      { path: 'reset_password', name: 'ResetPassword', component: ResetPassword },
      { path: 'resend_confirmation_email', name: 'ResendConfirmationEmail', component: ResendConfirmationEmail },
    ],
  },

  // Profile routes (no prefix)
  {
    path: '/profile',
    component: AccountContainer,
    children: [
      { path: '', name: 'MyAccount', component: MyAccount },
      { path: 'plan', name: 'MyPlan', component: MyPlan },
      { path: 'settings', name: 'MySetting', component: MySetting },
      { path: 'tasks', name: 'MyTask', component: MyTask },
    ],
  },

  // Catch all
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

// =============================
// CREATE ROUTER
// =============================
const router = createRouter({
  history: createWebHistory(),
  routes,
})

// =============================
// BEFORE EACH -> SET LOCALE & PRESERVE LANG
// =============================
router.beforeEach((to, from, next) => {
  const currentLang = from.params.lang as string
  const targetLang = to.params.lang as string
  const i18nLocale = i18n.global.locale.value

  // Check if this is an explicit language change (i18n locale already updated)
  // If i18n locale doesn't match the current route lang, it means user explicitly changed language
  const isExplicitLanguageChange =
    (i18nLocale === 'en' && !targetLang) || // Switching to English
    (i18nLocale !== 'en' && targetLang === i18nLocale) || // Switching to vi/ja
    i18nLocale !== currentLang // Any locale mismatch indicates explicit change

  // Only preserve lang if NOT an explicit language change
  if (!isExplicitLanguageChange && !targetLang && (currentLang === 'vi' || currentLang === 'ja')) {
    // Preserve the current language by redirecting to the same route with lang param
    next({
      name: to.name,
      params: {
        ...to.params,
        lang: currentLang,
      },
      query: to.query,
      hash: to.hash,
    })
    return
  }

  // Set locale based on target route
  const lang = targetLang || 'en'
  if (lang === 'vi' || lang === 'ja') {
    i18n.global.locale.value = lang
  } else {
    i18n.global.locale.value = 'en'
  }
  next()
})

// =============================
// AFTER EACH -> SCROLL TOP
// =============================
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
